import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { color } from '@deerplusofficial/pos-helper';
import ButtonBase from '../ButtonBase/ButtonBase';

export const Button = styled(ButtonBase)`
  ${props =>
    props.disabled &&
    css`
      pointer-events: none;
    `};
  flex: 1 0 calc((100% - 2px) / 3);
  background-color: ${color.calculator.button};
  border-bottom: 1px solid ${color.calculator.border};
  box-sizing: content-box;
  &:nth-child(3n-1),
  &:nth-child(3n) {
    border-left: 1px solid ${color.calculator.border};
  }
  &:active {
    background-color: ${color.calculator.buttonActive};
  }
`;

export default class Key extends React.PureComponent {
  static propTypes = {
    name: PropTypes.string,
    disabled: PropTypes.bool,
    onClick: PropTypes.func,
  };

  static defaultProps = {
    name: '',
    disabled: false,
    onClick: _.identity,
  };

  onClick = () => {
    const { onClick, name } = this.props;

    onClick({ key: name });
  };

  render() {
    const { children, disabled } = this.props;

    return (
      <Button onClick={this.onClick} disabled={disabled}>
        {children}
      </Button>
    );
  }
}



// WEBPACK FOOTER //
// ../pos-master/packages/pos-components/src/Calculator/Key.jsx